import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";
import { Article } from "@/types/article";

export const insertFirstArticle = async (): Promise<Article> => {
  console.log('🔍 Starting to insert first article...');
  
  try {
    const { data: existingArticles, error: checkError } = await supabase
      .from('articles')
      .select('*')
      .eq('title', 'Why Separation Happens')
      .maybeSingle();

    if (checkError) {
      console.error('❌ Error checking for existing article:', checkError);
      throw checkError;
    }

    if (existingArticles) {
      console.log('⚠️ Article already exists:', existingArticles);
      return existingArticles;
    }

    console.log('✨ No existing article found, proceeding with insertion...');

    const { data, error } = await supabase
      .from('articles')
      .insert({
        title: "Why Separation Happens",
        category: "journey-stages",
        summary: "Common reasons for the separation phase in twin flames",
        content: `// ... keep existing code (long article content)`
      })
      .select()
      .single();

    if (error) {
      console.error('❌ Error inserting article:', error);
      throw error;
    }

    console.log('✅ First article inserted successfully:', data);
    toast({
      title: "Success",
      description: "Article 'Why Separation Happens' has been added!",
    });
    return data;
  } catch (error) {
    console.error('❌ Error in insertFirstArticle:', error);
    toast({
      title: "Error",
      description: "Failed to insert the article. Please try again.",
      variant: "destructive",
    });
    throw error;
  }
};

export const fetchArticles = async () => {
  console.log('🔄 Fetching latest articles...');
  try {
    const { data: fetchedArticles, error: fetchError } = await supabase
      .from("articles")
      .select("*")
      .order("created_at", { ascending: false })
      .limit(8);

    if (fetchError) {
      console.error("❌ Error fetching articles:", fetchError);
      throw fetchError;
    }

    const validArticles = fetchedArticles?.filter(article => article && article.title && article.category) || [];
    
    console.log("📚 Fetched articles:", validArticles);
    
    if (validArticles.length === 0) {
      console.log("⚠️ No articles found in the database, attempting to insert first article");
      const insertedArticle = await insertFirstArticle();
      console.log("✅ First article has been added:", insertedArticle);
      
      toast({
        title: "Success",
        description: "First article has been added automatically!",
      });
      
      return [insertedArticle];
    }

    return validArticles;
  } catch (err) {
    console.error("❌ Error in fetchArticles:", err);
    throw err;
  }
};